import React from 'react';
import { Utensils } from 'lucide-react';
import ProjectTemplate from './ProjectTemplate';

const NutriScan = () => {
  const project = {
    title: 'Yamai NutriScan',
    tagline: 'Metabolic and Nutritional Signal Analysis',
    icon: Utensils,
    color: '#10B981',
    overview: 'Yamai NutriScan analyzes metabolic biomarkers, dietary patterns, and nutritional signals to provide personalized health insights and early detection of metabolic disorders. By combining blood work analysis with dietary data, we help identify risks for diabetes, metabolic syndrome, nutritional deficiencies, and other conditions before they become clinically significant.',
    problems: [
      {
        title: 'Rising Metabolic Disease',
        description: 'Diabetes and metabolic syndrome are epidemic, yet often detected only after complications develop.',
      },
      {
        title: 'Complex Biomarker Relationships',
        description: 'Metabolic health involves complex interactions between dozens of biomarkers that are difficult to interpret holistically.',
      },
      {
        title: 'Lack of Personalization',
        description: 'Nutrition advice is often generic rather than tailored to individual metabolic profiles.',
      },
      {
        title: 'Reactive Rather Than Preventive',
        description: 'Current approaches focus on treating disease rather than preventing it through early intervention.',
      },
    ],
    solutions: [
      'Comprehensive biomarker analysis including glucose, lipid panels, hormones, vitamins, and inflammatory markers',
      'AI-powered pattern recognition to identify metabolic dysfunction before clinical thresholds are reached',
      'Personalized nutrition recommendations based on individual metabolic profile',
      'Predictive risk scoring for type 2 diabetes, cardiovascular disease, and metabolic syndrome',
      'Explainable insights showing which biomarkers and patterns contributed to risk assessment',
    ],
    technology: 'Yamai NutriScan uses machine learning models trained on large-scale health and nutrition datasets to identify subtle metabolic patterns predictive of future disease. Our system integrates multiple data sources including lab results, dietary logs, and activity data to create comprehensive metabolic profiles. The explainability framework shows users exactly which factors are driving their health scores and recommendations.',
    roadmap: [
      {
        title: 'Data Integration & Model Development (2027)',
        description: 'Partner with health systems and research institutions to access diverse metabolic datasets',
      },
      {
        title: 'Validation Studies (2028)',
        description: 'Prospective studies demonstrating predictive accuracy for metabolic disease',
      },
      {
        title: 'Consumer App Development (2029)',
        description: 'Build patient-facing platform for personalized metabolic health insights',
      },
      {
        title: 'Market Launch (2030)',
        description: 'Release for both clinical and direct-to-consumer use',
      },
    ],
  };

  return <ProjectTemplate project={project} />;
};

export default NutriScan;